import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function SearchBanner() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 pt-10 md:px-6 md:pt-14">
      <div className="flex flex-col items-center rounded-lg border border-background-200/60 bg-background-100 px-5 py-8 text-center md:px-10 md:py-12">
        <h1 className="text-balance font-heading text-2xl font-extrabold text-foreground-950 md:text-4xl">
          鸭王在线观看 - 最新电影在线免费播放平台
        </h1>
        <p className="mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
          聚合动作、喜剧、爱情、科幻、悬疑等多种类型的高清影视资源，分类清晰、更新及时，随时随地畅享观影体验。
        </p>

        <form
          onSubmit={handleSubmit}
          className="mt-6 flex h-12 w-full max-w-xl items-center gap-2 rounded-full border border-background-300/60 bg-background-50 px-4 md:h-14"
        >
          <i className="ri-search-line text-lg text-foreground-500"></i>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="输入影片名称、类型或地区，例如：科幻"
            className="flex-1 bg-transparent text-sm text-foreground-950 placeholder:text-foreground-500 focus:outline-none md:text-base"
          />
          <button
            type="submit"
            className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm font-semibold text-background-950 transition-colors hover:bg-accent-400 md:px-6"
          >
            <i className="ri-search-line"></i>
            搜索
          </button>
        </form>

        <div className="mt-4 flex flex-wrap items-center justify-center gap-2 text-xs text-foreground-600">
          <span>热搜：</span>
          {["星际", "动作", "悬疑", "动画", "爱情"].map((word) => (
            <button
              key={word}
              type="button"
              onClick={() => navigate(`/search?q=${encodeURIComponent(word)}`)}
              className="cursor-pointer rounded-full border border-background-300/50 px-3 py-1 transition-colors hover:border-accent-500 hover:text-accent-500"
            >
              {word}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}